require('./impersonate.controller');
require('./impersonate.routing');

angular.module('bbl.module.impersonate', [
  'bbl.services',
  'bbl.module.impersonate.routing',
  'bbl.module.impersonate.controller',
]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/impersonate/impersonate.module.js
 ** module id = 404
 ** module chunks = 0
 **/